<template>
  <div>
    <div class="container-fluid container-froDesk">
      <div class="wrapper">
        <div class="content-page content-froDesk">
          <div class="content">
            <div class="row">
              <!-- 详情 -->
              <div class="col-lg-12">
                <div class="card">
                  <div class="card-body">
                    <div class="dropdown float-right">
                      <Breadcrumb :id='data.columnId' :active="1"></Breadcrumb>
                    </div>
                    <h3 class="header-title froDeskHeader-tit mb-3 pb-2">
                      <span class="tit">详情</span>
                      <span class="ml-1">Details</span>
                    </h3>
                    <div class="General-details pb-3">
                      <h3 class="genDet-tit text-center mb-4 pt-3">{{data.title}}</h3>
                      <div class="genDet-att text-muted text-center mb-4 pb-2">
                        <span class="p-2">发布人：{{data.author}}</span>
                        <span class="p-2">发布单位：{{data.unitName}}</span>
                        <span class="p-2">浏览量：{{data.viewNumber}}</span>
                      </div>
                      <div class="genDet-con" v-html="data.content"></div>
                      <div class="genDet-annex pt-3" v-if="data.eduAnnexes && data.eduAnnexes.length>0 && data.eduAnnexes[0]">
                        <dl class="row">
                          <dt class="col-2">
                            <i class="fa fa-paperclip mr-1 text-warning" aria-hidden="true"></i>
                            附件下载：
                          </dt>
                          <dd class="col-10">
                            <p class="mb-1" v-for="item in data.eduAnnexes" :key="item.id">
                              <a :href="uploadUrl+'/upload/download?openStyle=1&id='+item.id" :download="item.name">{{item.name}}</a>
                            </p>
                          </dd>
                        </dl>
                      </div>
                    </div>
                    <div class="row genDet-page pt-3">
                      <div class="col-6">
                        <h4 class="text-muted">
                          <span @click="handleArticleChange('prev')">
                            <i class="mdi mdi-arrow-left-thick mr-2"></i>
                            上一篇
                          </span>
                        </h4>
                        <a class="page_tit" @click="handleArticleChange('prev')">{{this.data.articNameVos && this.data.articNameVos[0]?this.data.articNameVos[0].name:"暂无"}}</a>
                      </div>
                      <div class="col-6 text-right">
                        <h4 class="text-muted">
                          <span @click="handleArticleChange('next')">
                            下一篇
                            <i class="mdi mdi-arrow-right-thick ml-2"></i>
                          </span>
                        </h4>
                        <a class="page_tit" @click="handleArticleChange('next')">{{this.data.articNameVos && this.data.articNameVos[1]?this.data.articNameVos[1].name:"暂无"}}</a>
                      </div>
                    </div>
                  </div>
                  <!-- end card-body-->
                </div>
                <!-- end card-->
              </div>
              <!-- end 详情-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getArticleDetail } from "@/api/before/home";
import Breadcrumb from "@/views/frontDesk/components/Breadcrumb.vue";
export default {
  name: "projectManagement",
  components: {
    Breadcrumb,
  },
  data() {
    return {
      id: 0,
      activeBreadcrumb: {},
      data: {},
      total: 0,
    };
  },
  watch: {
    $route: {
      handler() {
        this.id = parseInt(this.$route.params.id);
        this.getData();
      },
      deep: true,
    },
  },
  mounted() {
    this.id = parseInt(this.$route.params.id);
    this.getData();
  },
  methods: {
    getData() {
      getArticleDetail(this.id).then((res) => {
        if (res.code == 200) {
          this.data = res.data;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleArticleChange(type) {
      if (type == "prev") {
        if (!this.data.articNameVos[0]) return;
        this.id = this.data.articNameVos[0].id;
      } else if (type == "next") {
        if (!this.data.articNameVos[1]) return;
        this.id = this.data.articNameVos[1].id;
      }
      this.$router.push("/publicDetails/" + this.id);
    },
    handleFile(data) {
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = this.uploadUrl + "/upload/download?openStyle=1&id=" + data.id;
      link.target = "_blank";
      link.download = data.name;
      link.click();
    },
    toPage(url) {
      this.$router.push(url);
    },
  },
};
</script>
<style lang="scss" scoped>
/* 通用详情 */
.General-details,
.genDet-page {
  margin: 0 auto;
  max-width: 800px;
}
.genDet-att {
  border-bottom: 1px dashed #e3eaef;
}
.genDet-con {
  line-height: 2;
  text-indent: 2em;
}
.genDet-con img {
  margin: 0 auto 1rem;
  display: block;
  max-width: 100%;
}
.genDet-page {
  border-top: 1px solid #e3eaef;
}
.genDet-page .text-muted span {
  cursor: pointer;
}
.page_tit {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  display: inline-block;
}
</style>
